import { FC } from "react";
interface propErrorMessageInput{
    message:string,
    className?:string
}
const ErrorMessageInput: FC<propErrorMessageInput> = (props) => {
    return(
        <div className={props.className}>{props.message}</div>
    )
}
ErrorMessageInput.defaultProps={
    className:'text-danger'
}
export {ErrorMessageInput}